<ng-container *ngFor="let sectionTable of sectionData; let i = index">
    <table style="width: 100%">
        <ng-container *ngFor="let row of sectionTable">
            <ng-container *ngIf="row.rowType === 'TableHead'">
                <thead>
                    <tr
                        [style.color]="textColor"
                        class="big-row-min-height_plus-border-height black-border-down header"
                    >
                        <th class="title text-align-bottom">
                            <div class="big-row-min-height_plus-border-height">{{ row.t }}</div>
                        </th>
                        <th class="value text-align-bottom" [style.background-color]="backgroundColor">
                            {{ row.cV }}
                        </th>
                        <th class="value text-align-bottom" *ngIf="row.compareYears" [style.background-color]="backgroundColorPY">{{ row.pV }}</th>
                    </tr>
                </thead>
            </ng-container>

            <ng-container *ngIf="row.rowType === 'Row'">
                <tr [style.color]="textColor" class="row-min-height_plus-border-height gray-border-down">
                    <td class="title text-align-top">{{ row.t }}</td>
                    <td
                        [ngClass]="row.dataType === 'TEXT' ? 'title' : 'value'"
                        class="text-align-top value"
                        [style.background-color]="backgroundColor"
                    >
                        {{ row.cV }}
                    </td>
                    <td
                        [ngClass]="row.dataType === 'TEXT' ? 'title' : 'value'"
                        class="text-align-top value"
                        [style.background-color]="backgroundColorPY"
                        *ngIf="row.compareYears"
                    >
                        {{ row.pV }}
                    </td>
                </tr>
            </ng-container>
        </ng-container>
    </table>
    <br />
</ng-container>
